exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3YAl0KkiE16JbPH0r6SRWf{font-size:12px}", ""]);
// Exports
exports.locals = {
	"menuButton": "_3YAl0KkiE16JbPH0r6SRWf"
};